package com.devi3east.bashbuddy.footer.ui

data class ContactUsUiState(
    val name: String = "",
    val email: String = "",
    val phone: String = "",
    val message: String = "",
    val isLoading: Boolean = false,
    val successMessage: String? = null,
    val errorMessage: String? = null
)